<script setup>
import { onMounted, ref, useTemplateRef } from 'vue';

const props = defineProps({
  src: { type: String, required: true },
  thumbnail: { type: String, required: true },
  name: { type: String, required: true },
});

const emit = defineEmits(['close', 'chat', 'contact']);
const actionButtonClass =
  'acl-mobile-conversation-avatar-action flex min-h-12 items-center justify-center border-0 bg-white text-[#008069] active:bg-[#e9f5f1]';
const viewerRef = useTemplateRef('viewerRef');
const photoSrc = ref(props.src);

onMounted(() => viewerRef.value?.focus());

const onPhotoError = () => {
  if (photoSrc.value !== props.thumbnail) photoSrc.value = props.thumbnail;
};
</script>

<template>
  <Teleport to="body">
    <div
      ref="viewerRef"
      class="acl-mobile-conversation-avatar-viewer fixed inset-0 z-[2147483647] flex items-center justify-center bg-modal-backdrop-dark p-4"
      role="dialog"
      aria-modal="true"
      :aria-label="name"
      tabindex="-1"
      @click.self="emit('close')"
      @keydown.esc.stop="emit('close')"
    >
      <div class="acl-mobile-conversation-avatar-card w-[min(300px,calc(100vw-2rem),calc(100dvh-8rem))] overflow-hidden bg-white shadow-2xl">
        <div class="relative aspect-square w-full bg-n-slate-3">
          <img
            :src="photoSrc"
            :alt="name"
            class="size-full object-cover"
            @error="onPhotoError"
          />
          <div class="absolute inset-x-0 top-0 bg-gradient-to-b from-black/65 to-transparent p-3 text-white">
            <span class="block truncate text-base font-semibold">{{ name }}</span>
          </div>
        </div>
        <div class="acl-mobile-conversation-avatar-actions grid grid-cols-2 divide-x divide-n-weak border-t border-n-weak">
          <button
            type="button"
            :class="actionButtonClass"
            :aria-label="$t('AUTOMATION.ACTIONS.OPEN_CONVERSATION')"
            @click="emit('chat')"
          >
            <span
              class="acl-mobile-conversation-avatar-action-icon i-lucide-message-circle size-5"
              aria-hidden="true"
            />
          </button>
          <button
            type="button"
            :class="actionButtonClass"
            :aria-label="$t('CONVERSATION_SIDEBAR.ACCORDION.CONTACT_DETAILS')"
            @click="emit('contact')"
          >
            <span
              class="acl-mobile-conversation-avatar-action-icon i-lucide-contact size-5"
              aria-hidden="true"
            />
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>
